export default {
  // Route internationalization
  route: {
    dashboard: 'Painel',
    document: 'Documentação'
  },
  // Login page internationalization
  login: {
    title: 'Login',
    subTitle: 'Bem-vindo à Plataforma de Atacado de Contas no Exterior',
    formLogin: 'Login',
    formUserNamePlaceholder: 'Por favor, insira o nome de usuário',
    formPasswordPlaceholder: 'Por favor, insira a senha',
    formUserNameErrMsg: 'O nome de usuário não pode estar vazio',
    formPasswordErrMsg: 'A senha não pode estar vazia',
    formErrMsg: 'Erro de login, por favor atualize e tente novamente',
    formSuccess: 'Bem-vindo ao uso',
    forgotPassword: 'Esqueceu a senha?',
    noAccount: 'Ainda não tem uma conta?',
    register: 'Registrar agora',
    slogan1: 'Proteção rigorosa da privacidade, ninguém pode acessar informações de conteúdo',
    subSlogan1: 'Contas de alta qualidade, qualidade garantida, pós-venda sem preocupações',
    slogan2: 'Suporte a pagamento descentralizado de carteira blockchain, transações convenientes',
    subSlogan2:
      'Internacionalização, configuração de roteamento, gerenciamento de estado tudo incluído',
    slogan3: 'Estável e confiável, entrega rápida',
    subSlogan3:
      'Manutenção por equipe profissional, estabilidade de longo prazo, atualizações contínuas'
  },
  navbar: {
    退出: 'Sair'
  },
  common: {
    是: 'Sim',
    否: 'Não',
    登录成功: 'Login bem-sucedido',
    已在其他标签页打开: 'Já aberto em outra aba',
    请关闭当前标签页: 'Por favor, feche a aba atual',
    添加: 'Adicionar',
    删除: 'Excluir',
    编辑: 'Editar',
    取消: 'Cancelar',
    确认: 'Confirmar',
    分组: 'Grupo',
    确定删除吗: 'Tem certeza que deseja excluir?',
    确认删除: 'Confirmar exclusão',
    搜索用户: 'Pesquisar usuário',
    小时: 'Hora',
    天: 'Dia',
    表情: 'Emoji',
    图片: 'Imagem',
    历史: 'Histórico',
    快捷回复: 'Resposta rápida',
    常用表情: 'Emoji comum',
    手势: 'Gesto',
    心形: 'Coração',
    自然: 'Natureza',
    食物: 'Comida',
    节日: 'Festival',
    天气: 'Clima',
    消息管理: 'Gerenciamento de mensagens',
    全部: 'Todos',
    音频: 'Áudio',
    视频: 'Vídeo',
    文件: 'Arquivo',
    发送: 'Enviar',
    更多操作: 'Mais operações',
    请输入消息: 'Por favor, insira a mensagem',
    删除成功: 'Exclusão bem-sucedida',
    在线: 'Online',
    离线: 'Offline',
    封禁用户: 'Banir usuário',
    打开: 'Abrir',
    关闭: 'Fechar',
    暂无数据: 'Sem dados',
    已封禁: 'Banido',
    资料卡: 'Perfil',
    签名: 'Esta pessoa é preguiçosa e não deixou nada',
    手机号: 'Número de telefone',
    昵称: 'Apelido',
    性别: 'Gênero',
    备注: 'Observação',
    添加备注: 'Adicionar observação',
    邮箱: 'E-mail',
    发送消息: 'Enviar mensagem',
    修改备注: 'Modificar observação',
    操作成功: 'Operação bem-sucedida',
    操作失败: 'Serviço ocupado, por favor tente novamente mais tarde',
    全选: 'Selecionar todos',
    消息发送失败: 'Falha no envio da mensagem',
    请完善表单信息: 'Por favor, complete as informações do formulário',
    表单验证失败: 'Falha na validação do formulário',
    秒: 'Segundo',
    分钟前: 'Minutos atrás',
    刚刚: 'Agora mesmo',
    昨天: 'Ontem',
    前天: 'Anteontem',
    日: 'Dom',
    一: 'Seg',
    二: 'Ter',
    三: 'Qua',
    四: 'Qui',
    五: 'Sex',
    六: 'Sáb'
  },
  setting: {
    langSetting: 'Idioma',
    zh: 'Chinês',
    en: 'Inglês',
    pt: 'Português',
    ru: 'Russo'
  },
  xmlRequest: {
    系统出错: 'Erro do sistema',
    提示: 'Dica',
    确认: 'Confirmar',
    再想想: 'Pense novamente',
    当前登录已失效: 'Login atual expirado, por favor, faça login novamente',
    下载成功: 'Download bem-sucedido',
    下载失败: 'Falha no download',
    删除成功: 'Exclusão bem-sucedida',
    删除失败: 'Falha na exclusão',
    上传成功: 'Upload bem-sucedido',
    上传失败: 'Falha no upload',
    音频播放失败: 'Falha na reprodução do áudio',
    保存成功: 'Salvamento bem-sucedido',
    已发送: 'Enviado',
    '000000': 'Sucesso',
    '100001': 'Erro de parâmetro',
    '100002': 'Erro no código de verificação',
    '100003': 'Código de verificação expirado',
    '100004': 'Código de verificação ainda válido, por favor, tente novamente mais tarde',
    '100005': 'Erro na senha',
    '100006': 'Código expirado',
    '200001': 'Usuário não existe',
    '200002': 'Não é possível fazer login, conta está congelada',
    '200003':
      'Usuário inválido, por favor, faça logout e login novamente. Entre em contato com o administrador se tiver dúvidas!',
    '200004': 'Senha original incorreta',
    '400001': 'Dados não existem',
    '400002': 'Token expirado',
    '400003': 'Falha ao obter permissões, por favor, entre em contato com o administrador',
    '400005': 'Formato de número de telefone inválido',
    '400006': 'Contas alugadas não podem conversar entre si nos assentos',
    '400007': 'Número de destino não encontrado',
    '400008':
      'Este usuário TG já existe no sistema como nome de usuário ou número, não é permitido adicioná-lo novamente',
    '500001': 'Erro no serviço, por favor, atualize e tente novamente',
    '500002': 'Dados já existem',
    '500003': 'Contagem de operações excedeu o limite',
    '500004':
      'Operação de limite, por favor, faça logout e login novamente. Entre em contato com o administrador se tiver dúvidas!',
    '500005': 'Servidor ocupado',
    '500006': 'Chat com número de destino existe',
    501: 'Falha ao obter lista',
    502: 'Nome de usuário não pode estar vazio',
    503: 'Agente não encontrado',
    504: 'Consulta falhou, tente novamente mais tarde',
    505: 'Falha na criação',
    506: 'Não existe',
    507: 'Falha na atualização',
    508: 'Agente não existe',
    509: 'Falha na exclusão',
    510: 'Parâmetros obrigatórios ausentes',
    511: 'Nome de usuário ou senha incorretos',
    512: 'Falha no login, tente novamente mais tarde',
    513: 'Falha ao obter estatísticas',
    514: 'Falha ao obter tendência de renda',
    515: 'Por favor, selecione o arquivo para upload',
    516: 'Falha ao obter lista de pedidos',
    517: 'Falha ao obter detalhes',
    518: 'Falha ao obter métodos de pagamento habilitados',
    519: 'Formato de parâmetro inválido',
    401: 'Usuário não existe ou estado de login inválido'
  },
  undefined: 'Serviço ocupado, tente novamente mais tarde',
  page: {
    退出: 'Sair',
    个人信息: 'Informações Pessoais',
    点击联系客服: 'Clique para Contatar o Suporte',
    余额: 'Saldo',
    主页: 'Página Inicial',
    购买账户: 'Comprar Conta',
    购买记录: 'Histórico de Compras',
    客服: 'Atendimento ao Cliente',
    充值: 'Recarga',
    登录: 'Login',
    在线客服: 'Suporte Online',
    实时订单: 'Pedidos em Tempo Real',
    当前在线人数: 'Usuários Online Atualmente',
    今日售出账号: 'Contas Vendidas Hoje',
    订单号: 'Número do Pedido',
    下单时间: 'Hora do Pedido',
    未登录: 'Não Logado',
    账号列表: 'Lista de Contas',
    全部: 'Todos',
    库存: 'Estoque',
    价格: 'Preço',
    操作: 'Operação',
    购买: 'Comprar',
    '本站售出账号请妥善保存，7天后删除数据':
      'Por favor, mantenha as informações da conta em segurança, os dados serão excluídos após 7 dias',
    请输入订单号: 'Por favor, insira o número do pedido',
    账号类型: 'Tipo de Conta',
    请选择账号类型: 'Por favor, selecione o tipo de conta',
    购买时间: 'Hora da Compra',
    搜索: 'Pesquisar',
    重置: 'Redefinir',
    充值类型: 'Tipo de Recarga',
    充值金额: 'Valor da Recarga',
    立即充值: 'Recarregar Agora',
    充值通告: 'Aviso de Recarga',
    充值记录: 'Histórico de Recargas',
    订单ID: 'ID do Pedido',
    请输入订单ID: 'Por favor, insira o ID do pedido',
    发送者钱包地址: 'Endereço da Carteira do Remetente',
    接收者钱包地址: 'Endereço da Carteira do Destinatário',
    交易哈希: 'Hash da Transação',
    金额: 'Valor',
    类型: 'Tipo',
    状态: 'Status',
    时间: 'Hora',
    订单编号: 'Número do Pedido',
    您的钱包地址: 'Seu Endereço de Carteira',
    系统钱包地址: 'Endereço da Carteira do Sistema',
    确认充值: 'Confirmar Recarga',
    复制: 'Copiar',
    当前USDT支付区块网络协议为TRC20:
      'O protocolo atual da rede blockchain para pagamento USDT é TRC20',
    请使用链手机钱包扫码支付:
      'Por favor, certifique-se de que sua carteira está autorizada, caso contrário o sistema não poderá completar o pagamento',
    过程中产生的交易手续费由您自行承担:
      'As taxas de transação incorridas durante o processo são de sua responsabilidade',
    时: 'Hora',
    分: 'Minuto',
    秒: 'Segundo',
    请输入你的钱包地址: 'Por favor, insira seu endereço de carteira',
    查看详情: 'Ver Detalhes',
    复制账号: 'Copiar Conta',
    进入管理端: 'Entrar no Admin',
    进入用户端: 'Entrar no Portal do Usuário',
    今日已出售账号: 'Contas Vendidas Hoje',
    用户: 'Usuário',
    '请先安装 TronLink 钱包': 'Por favor, instale a carteira TronLink primeiro',
    请输入您的钱包地址: 'Por favor, insira seu endereço de carteira',
    充值详情: 'Detalhes da Recarga',
    充值成功: 'Recarga Bem-sucedida',
    充值失败: 'Falha na Recarga',
    充值中: 'Recarregando',
    充值状态: 'Status da Recarga',
    充值时间: 'Hora da Recarga',
    订单支付: 'Pagamento do Pedido',
    应付总额: 'Total a Pagar',
    支付: 'Pagar',
    购买数量: 'Quantidade de Compra',
    购买成功: 'Compra Bem-sucedida',
    产品名称: 'Nome do Produto',
    产品描述: 'Descrição do Produto',
    账号: 'Conta',
    密码: 'Senha',
    支付金额: 'Valor do Pagamento',
    订单状态: 'Status do Pedido',
    账号信息: 'Informações da Conta',
    已完成: 'Concluído',
    处理中: 'Em Processamento',
    连接钱包: 'Conectar Carteira',
    已连接钱包: 'Carteira Conectada',
    钱包余额: 'Saldo da Carteira',
    请先连接钱包: 'Por favor, conecte a carteira primeiro',
    未获取到钱包地址: 'Falha ao obter endereço da carteira',
    钱包连接成功: 'Carteira conectada com sucesso',
    链接钱包: 'Vincular Carteira',
    手机钱包App扫码支付: 'Pagar com QR code do app da carteira',
    浏览器TronLink支付: 'Pagar com TronLink no navegador',
    钱包已连接: 'Carteira conectada',
    钱包详情: 'Detalhes da Carteira',
    请先安装TronLink钱包: 'Por favor, instale a carteira TronLink primeiro',
    钱包地址已复制: 'Endereço da carteira copiado',
    复制失败: 'Falha ao copiar',
    连接钱包失败: 'Falha ao conectar carteira',
    检查授权状态失败请刷新页面重试:
      'Falha ao verificar status de autorização, por favor atualize e tente novamente',
    '授权超时，请重新尝试': 'Tempo limite de autorização, por favor tente novamente',
    请输入当前连接的钱包地址: 'Por favor, insira o endereço da carteira atualmente conectada',
    '授权请求已发送，请在钱包中确认':
      'Solicitação de autorização enviada, por favor confirme na carteira',
    请先完成授权操作: 'Por favor, complete a autorização primeiro',
    '支付失败，请重试': 'Falha no pagamento, por favor tente novamente',
    请安装钱包应用: 'Por favor, instale o aplicativo da carteira',
    用户拒绝了授权请求: 'Usuário rejeitou a solicitação de autorização',
    获取钱包余额失败: 'Falha ao obter saldo da carteira',
    请在钱包中完成授权操作: 'Por favor, complete a autorização na carteira',
    授权成功: 'Autorização bem-sucedida',
    授权失败: 'Falha na autorização',
    支付成功: 'Pagamento bem-sucedido',
    支付失败: 'Falha no pagamento',
    请使用手机钱包扫码: 'Por favor, use o aplicativo da carteira para pagar',
    授权成功正在处理支付: 'Autorização bem-sucedida, processando o pagamento...',
    钱包地址为空: 'Endereço da carteira vazio',
    USDT合约地址未配置: 'Contrato USDT não configurado',
    系统钱包地址未配置: 'Endereço da carteira do sistema não configurado',
    合约交互失败: 'Falha na interação com o contrato',
    钱包地址未获取: 'Falha ao obter endereço da carteira',
    您的USDT余额不足: 'Seu saldo USDT é insuficiente',
    授权失败请重试: 'Falha na autorização, por favor tente novamente',
    钱包连接失败: 'Falha ao conectar carteira',
    订单详情: 'Detalhes da encomenda',
    最小充值金额: 'Valor mínimo de recarga',
    最小充值金额说明: 'Por favor, insira o valor mínimo de recarga e sua descrição',
    保持钱包状态正常:
      'Por favor, certifique-se de que sua carteira está autorizada, caso contrário o sistema não poderá completar o pagamento',
    继续充值: 'Continuar recarga',
    充值成功点击刷新返回首页:
      'Recarga bem-sucedida, clique em atualizar para retornar à página inicial',
    取消: 'Cancelar'
  },
  register: {
    title: 'Registro',
    subTitle: 'Criar nova conta',
    formRegister: 'Registrar',
    formUserNamePlaceholder: 'Por favor, insira o nome de usuário',
    formEmailPlaceholder: 'Por favor, insira o e-mail',
    formPasswordPlaceholder: 'Por favor, insira a senha',
    formConfirmPasswordPlaceholder: 'Por favor, confirme a senha',
    formUserNameErrMsg: 'O nome de usuário não pode estar vazio',
    formEmailErrMsg: 'O e-mail não pode estar vazio',
    formEmailFormatErrMsg: 'Por favor, insira um endereço de e-mail válido',
    formPasswordErrMsg: 'A senha não pode estar vazia',
    formPasswordLengthErrMsg: 'A senha deve ter pelo menos 6 caracteres',
    formConfirmPasswordErrMsg: 'Por favor, confirme a senha',
    formPasswordNotMatchErrMsg: 'As senhas não coincidem',
    formAgreementLabel: 'Eu li e concordo com',
    formPrivacyLink: 'Política de Privacidade',
    formAgreementAnd: 'e',
    formTermsLink: 'Termos de Serviço',
    formAgreementErrMsg:
      'Por favor, leia e concorde com a Política de Privacidade e os Termos de Serviço',
    formHaveAccount: 'Já tem uma conta?',
    formLoginLink: 'Login',
    success: 'Registro bem-sucedido',
    error: 'Falha no registro',
    inviteCode: 'Código de convite (opcional)'
  },
  forgotPassword: {
    title: 'Esqueceu a Senha',
    subTitle:
      'Por favor, insira seu endereço de e-mail, enviaremos um código de verificação para redefinir sua senha',
    formEmailPlaceholder: 'Por favor, insira o e-mail',
    formCodePlaceholder: 'Por favor, insira o código de verificação',
    formEmailErrMsg: 'O e-mail não pode estar vazio',
    formEmailFormatErrMsg: 'Por favor, insira um endereço de e-mail válido',
    formCodeErrMsg: 'O código de verificação não pode estar vazio',
    formSendCode: 'Enviar Código',
    formSubmit: 'Redefinir Senha',
    formBackToLogin: 'Voltar ao Login',
    formEmailRequired: 'Por favor, insira o endereço de e-mail primeiro',
    codeSent: 'Código de verificação enviado',
    codeSendError: 'Falha ao enviar código de verificação',
    success: 'Redefinição de senha bem-sucedida',
    error: 'Falha na redefinição de senha'
  }
};
